<section #discoverTitleRef class="w-full h-screen bg-white p-10 overflow-hidden">
  <div class="flex flex-col items-center justify-evenly h-full">
    <div #discoverTitleRef2 class="flex flex-col items-center justify-center gap-4">
      <h2
        i18n="discover|Discover and join heading@@discover.title"
        appScrollAnimate="animate-fade-in-up"
        [scrollThreshold]="0"
        class="md:text-3xl text-2xl font-bold text-black opacity-0 text-center"
      >
        Discover & Join
      </h2>
      <p
        i18n="discover|Discover section subtitle@@discover.subtitle"
        appScrollAnimate="animate-fade-in-up"
        [scrollThreshold]="0"
        class="text-black text-center text-sm md:text-base font-medium opacity-0"
      >
        Explore a live feed of upcoming matches or sports events
      </p>
    </div>
    <div
      appScrollAnimate="animate-fade-in-up"
      class="opacity-0 relative w-full flex items-center justify-center py-6"
    >
      <!-- Infinite scrolling strip — breaks out of padded container to span full viewport width -->
      <div
        class="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-screen flex items-center pointer-events-none select-none"
      >
        <div #sportTrack class="sport-track flex gap-10 items-center">
          @for (sport of trackImages; track $index) {
            <img
              [src]="sport.src"
              [alt]="sport.alt"
              class="w-24 h-24 md:w-32 md:h-32 object-contain shrink-0 opacity-80"
            />
          }
        </div>
      </div>
      <!-- Phone image on top -->
      <img
        src="hero_image/mobile_left.png"
        alt="Discover Section mobile"
        class="relative z-10 w-44 md:w-56 drop-shadow-2xl"
      />
    </div>
  </div>
</section>
